export default __webpack_public_path__ + "static/laminated-29b359ecc483002cdf3e7cf886f6a3e0.jpg";